import React from 'react';
import PropTypes from 'prop-types';

import S from 'app/components/layout/StackedLayout.styled';

const StackedLayout = ({ children, ...restProps }) => (
  <S.StackedLayout {...restProps}>{children}</S.StackedLayout>
);

StackedLayout.propTypes = {
  children: PropTypes.node.isRequired,
  hasPaddingTop: PropTypes.bool,
  hasMarginTop: PropTypes.bool,
};
StackedLayout.defaultProps = {
  hasPaddingTop: false,
  hasMarginTop: false,
};

const ContentBlock = ({ children, ...rest }) => (
  <S.StackedLayout.ContentBlock {...rest}>
    {children}
  </S.StackedLayout.ContentBlock>
);

ContentBlock.propTypes = {
  children: PropTypes.node.isRequired,
  isContained: PropTypes.bool,
  gutterMobile: PropTypes.number,
  gutterTablet: PropTypes.number,
  gutterDesktop: PropTypes.number,
};

ContentBlock.defaultProps = {
  isContained: false,
  gutterMobile: 48,
  gutterTablet: 72,
  gutterDesktop: 96,
};

StackedLayout.ContentBlock = ContentBlock;

export default StackedLayout;
